import { Button } from "@components/atoms/Button"
import { ResponsiveImage } from "@components/atoms/ResponsiveImage"
import { cn } from "@utils/tw"
import { defineBlock, EditableText, InnerBlocks } from "eddev/blocks"

export const meta: BlockMeta = {
  title: "Expandable",
  tags: ["#page"],
}

export default defineBlock("content/expandable", (props) => {
  return (
    <div className="content-sized my-9 flex flex-col">
      <InnerBlocks
        allowedBlocks={["content/expandable-item"]}
        defaultBlocks={[["content/expandable-item", {}]]}
        orientation="vertical"
      />
    </div>
  )
})
